import { useState } from "react";
import { cn } from "@/lib/utils";
import { ChevronDown, ChevronUp } from "lucide-react";

interface AccordionViewProps {
    id: string;
    data: any;
    renderElement: (element: any) => React.ReactNode;
}

export const AccordionView = ({
    id,
    data,
    renderElement,
}: AccordionViewProps) => {
    const [openItems, setOpenItems] = useState<number[]>([0]);
    const items = data.items || [];

    const toggleItem = (index: number) => {
        setOpenItems((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    return (
        <div
            className="w-full flex flex-col"
            style={{
                gap: `${data.gap || 8}px`,
                padding: `${data.padding || 16}px`,
            }}
        >
            {items.map((item: any, index: number) => {
                const isOpen = openItems.includes(index);
                return (
                    <div
                        key={item.id || index}
                        className="border rounded-lg overflow-hidden transition-all"
                        style={{
                            borderRadius: `${data.borderRadius || 8}px`,
                            borderColor: isOpen ? data.activeColor : data.inactiveColor,
                        }}
                    >
                        {/* Accordion Header */}
                        <button
                            onClick={() => toggleItem(index)}
                            className="w-full flex items-center justify-between px-4 py-3 transition-colors"
                            style={{
                                backgroundColor: isOpen ? data.activeColor : data.inactiveColor,
                                color: isOpen ? data.activeTextColor : data.inactiveTextColor,
                            }}
                        >
                            <span className="font-medium">{item.title}</span>
                            {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                        </button>

                        {/* Accordion Content */}
                        <div
                            className={cn(
                                "transition-all duration-200 ease-in-out",
                                isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                            )}
                            style={{
                                backgroundColor: data.contentBackgroundColor,
                            }}
                        >
                            <div className="p-4">
                                {item.elements && item.elements.length > 0 ? (
                                    item.elements.map((element: any) => (
                                        <div key={element.id} className="mb-4 last:mb-0">
                                            {renderElement(element)}
                                        </div>
                                    ))
                                ) : null}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
